import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { AuthService } from "@app/modules/shared/services/auth.service";
import { Router } from "@angular/router";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { UtilService } from "@app/modules/shared/services/util.service";
import { ProfileComponent } from "@dashboard/components/profile/profile.component";

@Component({
  selector: "kl-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @Output() onShowSidebar = new EventEmitter<any>();
  @ViewChild("logoutMenu") logoutMenu;
  @ViewChild("logoutMenuOnline") logoutMenuOnline;
  @ViewChild("logoutMenuIcon") logoutMenuIcon;
  full_name = "";
  selectedLanguage: string;
  showNotification = false;
  showMessage = false;
  toggleNotificationStatus = false;
  toggleMessageStatus = false;
  showMobileMenu = false;

  userProfile: {
    username: string;
    full_name: string;
    email: string;
    curr_account_id: number;
    roles: Array<{
      role: {
        status: string;
        code: string;
        description: string;
        type: string;
        id: number;
      };
      id: number;
    }>;
    status: string;
    password_expired: number;
    localization: string;
    id: number;
  };
  company;
  period: any;
  showLogoutMenu = false;

  constructor(
    private auth: AuthService,
    private router: Router,
    private utilService: UtilService,
    private _translate: TranslateService,
    private alertService: KlSweetAlertService,
    private explorerService: ExplorerService,
    private renderer: Renderer2
  ) {
    this.renderer.listen("window", "click", (e: Event) => {
      if (
        e.target !== this.logoutMenu.nativeElement &&
        e.target !== this.logoutMenuIcon.nativeElement &&
        e.target !== this.logoutMenuOnline.nativeElement
      ) {
        this.showLogoutMenu = false;
      }
    });
    explorerService.userStream$.subscribe((response) => {
      if (response) {
        this.userProfile = response;
      }
    });
  }

  ngOnInit() {
    if (localStorage.getItem("currentLanguage")) {
      this.selectedLanguage = localStorage.getItem("currentLanguage");
    } else {
      this.selectedLanguage = "tr";
    }
    this.selectLang(this.selectedLanguage);
  }

  ngAfterViewInit() {}

  openTab() {
    const tabConfig = <TabConfig>{
      id: "profile",
      icon: "fal fa-profile",
      title: "profile",
      isCloseable: true,
      childTemplate: <DynamicComponent>{
        mode: "list",
        template: ProfileComponent,
      },
    };
    this.explorerService.openTab(tabConfig);
  }

  toggleSidebar() {
    this.onShowSidebar.emit();
  }

  selectLang(lang: string) {
    localStorage.setItem("currentLanguage", lang);
    sessionStorage.setItem("currentLanguage", lang);
    this._translate.use(lang);
  }

  _logout() {
    this.alertService.alert(
      {
        title: "Çıkış yapılıyor",
        text: "Çıkış yapmak istediğinizden emin misiniz?",
      },
      () => this.logout(),
      () => {}
    );
  }

  logout() {
    AuthService.logout(() => {
      this.router.navigateByUrl("/auth");
    });
  }

  lockScreen() {
    localStorage.setItem("lock-screen", "true");
    this.router.navigateByUrl("/lock-screen");
  }

  reload() {
    this.explorerService.closeAllTab(true);
  }

  togglePanel(panelName) {
    if (panelName === "notification") {
      this.showNotification = !this.showNotification;
    } else if (panelName === "message") {
      this.showMessage = !this.showMessage;
    }
  }

  toggleStatus(panelName) {
    if (panelName === "notification") {
      this.toggleNotificationStatus = !this.toggleNotificationStatus;
    } else if (panelName === "message") {
      this.toggleMessageStatus = !this.toggleMessageStatus;
    }
  }

  outsideClick(panelName, event) {
    if (panelName === "notification") {
      if (!this.toggleNotificationStatus) {
        this.showNotification = event;
      }
    } else if (panelName === "message") {
      if (!this.toggleMessageStatus) {
        this.showMessage = event;
      }
    }
  }

  showMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  }

  mobileMenuOutsideClick() {
    this.showMobileMenu ? (this.showMobileMenu = false) : null;
  }
}
